import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

const CardReceive: React.FC<Props> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    width={24}
    height={24}
    {...props}
  >
    <path
      d="M14.5 9.25H2C1.59 9.25 1.25 8.91 1.25 8.5C1.25 8.09 1.59 7.75 2 7.75H14.5C14.91 7.75 15.25 8.09 15.25 8.5C15.25 8.91 14.91 9.25 14.5 9.25Z"
      fill="currentColor"
    />
    <path
      d="M6 16.25H8C8.13386 16.25 8.25 16.3661 8.25 16.5C8.25 16.6339 8.13386 16.75 8 16.75H6C5.86614 16.75 5.75 16.6339 5.75 16.5C5.75 16.3661 5.86614 16.25 6 16.25Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
      fill="currentColor"
    />
    <path
      d="M17.56 21.25H6.44C2.46 21.25 1.25 20.05 1.25 16.11V7.89C1.25 3.95 2.46 2.75 6.44 2.75H14.5C14.91 2.75 15.25 3.09 15.25 3.5C15.25 3.91 14.91 4.25 14.5 4.25H6.44C3.3 4.25 2.75 4.79 2.75 7.89V16.1C2.75 19.2 3.3 19.74 6.44 19.74H17.55C20.69 19.74 21.24 19.2 21.24 16.1V14.02C21.24 13.61 21.58 13.27 21.99 13.27C22.4 13.27 22.74 13.61 22.74 14.02V16.1C22.75 20.05 21.54 21.25 17.56 21.25Z"
      fill="currentColor"
    />
    <path
      d="M20 10.25C19.9 10.25 19.81 10.23 19.71 10.19C19.43 10.07 19.25 9.8 19.25 9.5V3.5C19.25 3.09 19.59 2.75 20 2.75C20.41 2.75 20.75 3.09 20.75 3.5V7.69L21.47 6.97C21.76 6.68 22.24 6.68 22.53 6.97C22.82 7.26 22.82 7.74 22.53 8.03L20.53 10.03C20.39 10.17 20.2 10.25 20 10.25Z"
      fill="currentColor"
    />
    <path
      d="M20 10.2499C19.81 10.2499 19.62 10.1799 19.47 10.0299L17.47 8.02994C17.18 7.73994 17.18 7.25994 17.47 6.96994C17.76 6.67994 18.24 6.67994 18.53 6.96994L20.53 8.96994C20.82 9.25994 20.82 9.73994 20.53 10.0299C20.38 10.1799 20.19 10.2499 20 10.2499Z"
      fill="currentColor"
    />
  </svg>
);

export default CardReceive;
